import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <h2 className="font-heading text-2xl text-foreground-900 md:text-3xl">全频道分类</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">覆盖热血、恋爱、治愈、科幻等八大频道，一键直达你喜欢的动漫世界</p>
          </div>
          <Link to="/category" className="inline-flex items-center whitespace-nowrap text-sm font-medium text-primary-600 transition hover:text-primary-700">
            查看全部分类 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group rounded-lg border border-background-200 bg-background-50 p-5 transition hover:-translate-y-1 hover:border-primary-300 md:p-6"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${c.color}`}>
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-900">{c.name}动漫</h3>
              <p className="mt-1.5 text-xs text-foreground-600 md:text-sm">{c.desc}</p>
              <span className="mt-3 inline-flex items-center text-xs font-medium text-primary-600">
                进入频道 <i className="ri-arrow-right-line ml-1 transition group-hover:translate-x-0.5"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}